/**
 * Minimal Skeleton (LIBRARY-UI owned) — loading placeholder for grids/lists. The
 * foundation ShadCN set ships no Skeleton; this is a tiny animated div.
 */
import { cn } from '@/lib/utils';

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-[var(--muted)]', className)}
      aria-hidden="true"
    />
  );
}
